export const TranslationService = {
    dictionary: {
        titre_principal: {fr: "Simulateur d'intérêts et de rentabilité", en: "Interest Calculator"},

        titre_caracteristiques_ot: {
            fr: "Caractéristiques de votre placement (OT) - convention de base : Exact/Exact ISMA", 
            en: "Investment features (OT) - convention: Exact/Exact ISMA"
        },

        titre_caracteristiques_bonds: {
            fr: "Caractéristiques de votre placement (BT) - convention de base : Exact/360", 
            en: "Investment features (BT) - convention: Exact/360"
        },

        titre_ot: { fr: "OAT", en: "T-BOND" },
        titre_bons: { fr: "BAT", en: "T-BILL" },

        amortization_if: { fr: "IN FINE", en: "IN FINE" }, 
        amortization_acd: { fr: "Amortissable", en: "Fixed Delayed" }, 

        periodicity_year: { fr: "Annuelle", en: "Annual" }, 
        periodicity_semester: { fr: "Semestrielle", en: "Semi-Annual" }, 
        periodicity_trimester: { fr: "Trimestrielle", en: "Quaterly" }, 

        emetteur: {fr: "Emetteur", en: "Issuer"},
        isin: {fr: "Code ISIN", en: "ISIN Code"},
        mode_amortissement: {fr: "Mode d'Amortissement", en: "Depreciation method"},
        periodicite: {fr: "Periodicité", en: "Frequency"},
        date_valeur: {fr: "Date de valeur", en: "Value Date"},
        coupon: {fr: "Taux d'intérêt (coupon)", en: "Interest rate (coupon)"},
        differe: {fr: "Differé (en années)", en: "Deferred (in years)"},
        date_echeance: {fr: "Date d'échéance", en: "Maturity Date"},
        maturite: {fr: "Maturité en années", en: "Maturity in years"},
        maturite_jour: {fr: "Maturité (jours)", en: "Maturity (days)"},
        valeur_nominale: {fr: "Valeur nominale unitaire", en: "Nominal value per unit"},
        montant_placement: {fr: "Montant à placer", en: "Invested Amount"},

        titre_resultats: {fr: "Résultats de votre placement", en: "Investment Results"},
        determiner_prix: {fr: "Déterminer le prix", en: "Calculate Price"},
        determiner_rendement: {fr: "Déterminer le rendement", en: "Calculate Yield"},
        taux_rendement: {fr: "Taux de rendement du placement", en: "Yield"},
        taux_rendement_voulu: {fr: "Taux de rendement souhaité", en: "Yield preferrence"},
        coupon_couru: {fr: "Coupon Couru", en: "Accrued coupon interest"},
        prix_placement: {fr: "Prix du placement", en: "Investment price"},
        prix_placement_voulu: {fr: "Prix souhaité", en: "Price Preferrence"},
        montant_net: {fr: "Montant net", en: "Net amount"},
        interet_couru: {fr: "Dont interêts courus", en: "Including accrued interest"},
        interets: {fr: "Interêts", en: "Interest"},

        titre_tableau_amortissement: {fr: "Tableau d'amortissement (FCFA)", en: "Amortization plan"},
        afficher_tableau_amortissement: {fr: "Afficher le tableau d'amortissement", en: "Show amortization plan"},
        ta_fraction: {fr: "Fraction", en: "Fraction"},
        ta_date: {fr: "Date", en: "Date"},
        ta_encours_debut: {fr: "Encours Debut de période", en: "Outstanding Before"},
        ta_encours_fin: {fr: "Encours Fin de période", en: "Outstanding After"},
        ta_interet: {fr: "Intérêts", en: "Interest"},
        ta_amortissement: {fr: "Amortissement", en: "Amortization"},
        ta_service: {fr: "Service", en: "Service"},
        

        taux_pre_compte: {fr: "Taux Pré Compté", en: "Precounted Rate"},

        maturite_residuel: {fr: "Durée de vie résiduelle", en: "Residual Maturity"},
        
        close_modal: {fr: "Fermer", en: "Close"},

        years: {fr: "Ans", en: "Years"},
        days: {fr: "Jours", en: "Days"},

        datesInputErrorMessage: {
            fr: "La date d'échéance devrait être supérieure à la date de valeur",
            en: "Value date should be lower than maturity date"
        }
    },

    translate: (word, lang) => {
        let words = TranslationService.dictionary[word];
        return words ? lang === "fr" ? words.fr : words.en : '';
    },
};
